import { styled } from "@mui/material";

export const UnorderedList = styled("ul")(({ theme }) => ({
  paddingLeft: theme.spacing(4),
}));

export const OrderedList = styled("ol")(({ theme }) => ({
  paddingLeft: theme.spacing(4),
}));
